import * as yup from 'yup';

export const schema = yup.object().shape({
  first_name: yup.string().required('enterFirstName').matches(/^[aA-zZ\s\u0590-\u05fe ]+$/, 'enterValidFirstName'),
  last_name: yup.string().required('enterLastName').matches(/^[aA-zZ\s\u0590-\u05fe ]+$/, 'enterValidLastName'),
  email: yup.string().required('enterEmail').email('enterValidEmail'),
  phone: yup.string().required('enterPhone').matches(/^[0-9]+$/,'enterDigits').min(10,"enterValidPhone").max(10,"enterValidPhone"),
  degree: yup.string().notOneOf(['']).required('enterDegree'),
  faculty: yup.string().notOneOf(['']).required('enterFaculty'),
  checked: yup.bool().oneOf([true],'clickCheckbox')
});
export const fieldsForm =  { 
    first_name: {
      elementType: 'input',
      value: '',
      salesforce_id: 'tfa_307'
    },
    last_name: {
      elementType: 'input',
      value: '',
    },
    email: {
        elementType: 'input',
        value: '',
        salesforce_id:'tfa_35'
    },
    phone: {
        elementType: 'input',
        value: '',
        salesforce_id: 'tfa_36'

    },
    degree: {
      elementType: 'input',
      value: '',
      salesforce_id: 'tfa_41'

    },
    faculty: {
        elementType: 'input',
        value: '',
        salesforce_id: 'tfa_42'

      },
      checked: {
        value: true,
      },
    subject: {
      elementType: 'input',
      value: '',
      salesforce_id: 'tfa_37'
    },
  }